import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

function usePosLabels() {
  const { t } = useTranslation();
  return {
    noun: t('pos.noun'),
    verb: t('pos.verb'),
    adj: t('pos.adj'),
    adv: t('pos.adv'),
    prep: t('pos.prep'),
    conj: t('pos.conj'),
    pron: t('pos.pron'),
    det: t('pos.det'),
    interj: t('pos.interj'),
  };
}

export default function PosBadge({ pos, size = 'md', className }) {
  const posLabels = usePosLabels();
  if (!pos) return null;

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-0.5 text-xs',
    lg: 'px-2.5 py-1 text-sm',
  };

  return (
    <span className={cn(
      'font-medium rounded bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400',
      sizeClasses[size],
      className
    )}>
      {posLabels[pos] || pos}
    </span>
  );
}
